import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'proto-info-box',
  standalone: false,
  styleUrls: ['./info-box.component.scss'],
  templateUrl: './info-box.component.html',
})
export class InfoBoxComponent implements OnInit {
  @Input() title?: string;

  public ngOnInit(): void {
    // Initialization logic can go here
  }
}
